export default "__VITE_ASSET__AXsGS6oD__"